import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/firstdraft': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M384 192h-64v128h-128v128h-192v-25.6h166.4v-128h128v-128h89.6v25.6zM358.4 230.4h25.6v153.6h-128v128h-192v-25.6h166.4v-128h128v-128zM384 422.4v25.6h-64v64h-25.6v-89.6h89.6zM0 0h384v128h-128v128h-128v128h-128v-384z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/firstdraft.js
// module id = 827
// module chunks = 0